import {AfterContentInit, Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {ModalDialogEvents} from './modal-dialog-events';
import {ModalService} from '../modal.service';
import {ModalComponent} from '../modal.component';

@Component({
    selector: 'vui-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements AfterContentInit {
    @Output() public event$: EventEmitter<ModalDialogEvents>;
    @Input() public description: string;
    @HostBinding('class.loaded') public loaded: boolean;
    @Input() public title: string;

    constructor(private modalService: ModalService<ModalComponent>) {
        this.event$ = new EventEmitter<ModalDialogEvents>();
    }

    public ngAfterContentInit(): void {
        this.loaded = true;
    }

    /**
     *
     */
    public close(): void {
        this.event$.emit(ModalDialogEvents.CLOSED);
        this.modalService.unload().toPromise().then(() => {
            this.modalService.destroy();
        });
    }
}
